module.exports = __webpack_public_path__ + "assets/roboto-medium.423cd62b62b3b3121130fd7d2fddfa2b0ee6f675e159cdf652a073a7715f7f98.woff2";